import getToken from "./GetToken";

function parseRoleIds(raw) {
    if (!raw) {
        return [];
    }
    if (Array.isArray(raw)) {
        return raw;
    }
    if (typeof raw === 'string') {
        return raw.split(',').map((s) => s.trim()).filter(Boolean);
    }
    return [];
}

function SplitToken(){
    const token = getToken();
    if (!token){return};

    function parseJwt(token) {
        if (!token) { return; }
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    }

    const pulledToken = parseJwt(token);
    const userArray = Object.values(pulledToken);
    const userDataArray = userArray[3];
    const user = {
        id: userArray[0],
        userName: userArray[1],
        EmailId: userArray[2],
        isAdmin: userDataArray[0],
        downloaderOnly: userDataArray[1],
        hasReadPrivacyPolicy: userDataArray[2],
        hasConfirmedEmail: userDataArray[3],
        hasAcceptedDownloadPolicy: userDataArray[4],
        hasAcceptedUploadPolicy: userDataArray[5],
        roleIds: parseRoleIds(pulledToken.RoleIds),
        FirstName: userArray[4],
        LastName: userArray[5],
    };
    return user;
}

export default SplitToken;
